import { templateService } from "@features/template/TemplateService";
import { TemplateOutputDTO } from '@features/template/types';
import createEntitySlice from "@services/createEntitySlice";

const {
  reducer: TemplateReducer,
  actions: TemplateActions,
  fetchAll: fetchTemplates,
  fetchById: fetchTemplateById,
  createEntity: createTemplate,
  updateEntity: updateTemplate,
  deleteEntity: deleteTemplate,
} = createEntitySlice<TemplateOutputDTO>("Template", templateService);

export {
  TemplateReducer,
  TemplateActions,
  fetchTemplates,
  fetchTemplateById,
  createTemplate,
  updateTemplate,
  deleteTemplate,
}; 